import _ from 'lodash';
import MetadataDrivenParser from '../MetadataDrivenParser';

class MetadataDrivenContent {
    constructor(viewModel, pageDefinition, contentPath, type) {
        this.viewModel = viewModel;
        this.pageDefinition = pageDefinition;
        this.presentationModel = _.get(this.pageDefinition, contentPath);
        this.type = type;
    }
    
    get className() {
        return this.presentationModel.className;
    }

    get isVisible() {
        return this.presentationModel.visible === undefined ? true : this.presentationModel.visible;
    }

    get componentProps() {
        return this.presentationModel.componentProps;
    }

    get component() {
        return this.presentationModel.component;
    }

    get dataProps() {
        return this.presentationModel.dataProps || {};
    }

    get title() {
        return this.presentationModel.title;
    }

    get automationProperty() {
        if (__DEV__) {
            const {gwTest} = this.presentationModel;
            return gwTest;
        }
        return undefined;
    }

    parseContent(content) {
        this.content = content;
        const parser = new MetadataDrivenParser(this.pageDefinition, this.viewModel);
        this.items = parser.parseContent(this.content);
    }

    getItem(metadataDrivenItem) {
        return this.items.get(metadataDrivenItem);
    }
}
export default MetadataDrivenContent;